export default __webpack_public_path__ + "static/media/Glove4.92f5a821.svg";